import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DiallerService } from '@app/dialler/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, merge } from 'rxjs';
import { map, scan } from 'rxjs/operators';

@Component({
  selector: 'app-verify-close-modal',
  templateUrl: './verify-close-modal.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifyCloseModalComponent {
  viewModel$: Observable<ViewModel>;

  constructor(
    public activeModal: NgbActiveModal,
    private diallerSvc: DiallerService
  ) {
    this.viewModel$ = this.initViewModel();
  }

  private initViewModel() {
    return merge<Partial<ViewModel>>(
      this.diallerSvc.submitting.pipe(map((submitting) => ({ submitting })))
    ).pipe(scan((acc, value) => ({ ...acc, ...value }), {} as ViewModel));
  }

  confirmClose() {
    //this.diallerSvc.setIgnoreDisconnect(true);
    // submit the record then close the record
    this.diallerSvc.submitting.next(true);
    this.activeModal.close();
    this.diallerSvc.closeOBConfirmed();
  }
}

interface ViewModel {
  submitting: boolean;
}
